// extracted by mini-css-extract-plugin
module.exports =  {"item":"_93444fe79c--item--P8BSY"};